
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { PcgEmissionSource, PcgSource } from "src/store/pcg/types";
import { getGeiYearsByOrganizationIdAPI,getCategoriesByOrganizationIdAndYearAPI,getCategoriesByOrganizationUnifiedIdAndYearAPI, getPortafolioGeiYearsByOrganizationIdAPI
    } from "src/services/restcall";


export const getPortafolioGeiYearsByOrganizationId = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPortafolioGeiYearsByOrganizationIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getGeiYearsByOrganizationId = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiYearsByOrganizationIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getCategoriesByOrganizationUnifiedIdAndYear = (value:string,year:string,typeResult:string, versionId?: string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getCategoriesByOrganizationUnifiedIdAndYearAPI(value,year,typeResult, versionId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);      
        openNotification("Advertencia",message.message[0]+"."+" Ingrese data de actividad");    
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getCategoriesByOrganizationIdAndYear = (value:string,year:string, versionId?: string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getCategoriesByOrganizationIdAndYearAPI(value,year, versionId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);      
        openNotification("Advertencia",message.message[0]+"."+" Ingrese data de actividad");    
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


